export enum ChangeFieldsEnum {
  ALLOWANCE = 'allowanceStatus',
  PRESENCE = 'presence',
  MATERIALS = 'materialStatus',
  PRERESOLUTION = 'preResolutionStatus',
  DISCIPLINE = 'hasDisciplinaryViolation',
  MATERIAL_VIEW_STATUS = 'materialViewStatus'
}
